export type Language = 'es' | 'en';

export const AVAILABLE_LANGUAGES = {
  SPANISH: 'es' as Language,
  ENGLISH: 'en' as Language,
};

export const LANGUAGE_NAMES: Record<Language, string> = {
  es: 'Español',
  en: 'English',
};

export const LANGUAGE_FLAGS: Record<Language, string> = {
  es: 'circle-flags:es',
  en: 'circle-flags:us',
};

export const DEFAULT_LANGUAGE: Language = 'es';
